import { useTenant } from "@/contexts/TenantContext";
import { CheckCircle2, AlertCircle } from "lucide-react";

const INTEGRATIONS = [
  { key: "twilio", label: "Twilio SMS", desc: "Send SMS to leads. Two-way conversation in Message Center.", status: "mocked", category: "Comms" },
  { key: "sendgrid", label: "SendGrid / SMTP", desc: "Transactional and marketing email.", status: "mocked", category: "Comms" },
  { key: "stripe", label: "Stripe", desc: "Payments, subscriptions, invoices per tenant.", status: "mocked", category: "Billing" },
  { key: "google", label: "Google Auth", desc: "SSO login for end-user clients.", status: "mocked", category: "Auth" },
  { key: "anthropic", label: "Anthropic Claude", desc: "Claude Sonnet 4.5 powering the AI agent.", status: "live", category: "AI" },
];

export default function Settings() {
  const { activeTenant } = useTenant();
  return (
    <div className="p-8 max-w-5xl" data-testid="settings-page">
      <div className="mb-6">
        <div className="n-label">Integrations · {activeTenant?.name || "—"}</div>
        <h1 className="font-cab font-black text-4xl tracking-tight mt-1">External services</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {INTEGRATIONS.map((i) => {
          const live = i.status === "live";
          return (
            <div key={i.key} className="n-card p-5" data-testid={`integration-${i.key}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="n-label">{i.category}</div>
                  <div className="font-cab font-black text-xl mt-1">{i.label}</div>
                  <div className="text-sm text-[var(--n-text-sec)] mt-2">{i.desc}</div>
                </div>
                <div className={`flex items-center gap-1 text-xs font-mono-plex uppercase ${live ? "text-[var(--n-success)]" : "text-[var(--n-warning)]"}`}>
                  {live ? <CheckCircle2 size={14} /> : <AlertCircle size={14} />}
                  {live ? "live" : "mocked"}
                </div>
              </div>
              <div className="mt-4 flex items-center gap-2">
                <button className="n-btn-ghost n-btn text-xs" data-testid={`integration-${i.key}-configure`} disabled>
                  CONFIGURE
                </button>
                <div className="text-[10px] font-mono-plex text-[var(--n-text-muted)]">
                  {live ? "EMERGENT_LLM_KEY active" : "Connect API keys to enable"}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 n-card p-5">
        <div className="n-label">Platform info</div>
        <div className="grid grid-cols-3 gap-4 mt-3 font-mono-plex text-xs">
          <div><div className="text-[var(--n-text-muted)]">Stack</div><div className="text-white mt-1">React · FastAPI · MongoDB</div></div>
          <div><div className="text-[var(--n-text-muted)]">Auth</div><div className="text-white mt-1">JWT (httpOnly cookies)</div></div>
          <div><div className="text-[var(--n-text-muted)]">AI Model</div><div className="text-white mt-1">claude-sonnet-4-5</div></div>
        </div>
      </div>
    </div>
  );
}
